export const OVERLAY_MENU_CHANGE_EVENT = "academia:overlay-menu";
export const STAFF_SIDEBAR_MENU = "staff-sidebar";
export const PROFILE_MENU = "profile-menu";

/**
 * @param {Event} event
 * @returns {string}
 */
function overlayMenuNameFromEvent(event) {
  if (!(event instanceof CustomEvent)) {
    return "";
  }
  const detail = event.detail;
  if (!detail || typeof detail !== "object" || Array.isArray(detail)) {
    return "";
  }
  if (!("menuName" in detail)) {
    return "";
  }
  const menuName = detail.menuName;
  return typeof menuName === "string" ? menuName : "";
}

/**
 * Announces that an overlay menu opened so other overlays can close.
 * @param {string} menuName
 */
export function announceOverlayMenuOpen(menuName) {
  window.dispatchEvent(new CustomEvent(OVERLAY_MENU_CHANGE_EVENT, {
    detail: { menuName },
  }));
}

/**
 * @param {string} menuName
 * @param {() => void} onOtherMenuOpen
 * @param {{ compatibleMenus?: string[] }} [options]
 * @returns {() => void}
 */
export function onOtherOverlayMenuOpen(menuName, onOtherMenuOpen, options = {}) {
  const compatibleMenus = Array.isArray(options.compatibleMenus)
    ? options.compatibleMenus.filter((name) => typeof name === "string")
    : [];
  const handleOverlayChange = (event) => {
    const openedMenu = overlayMenuNameFromEvent(event);
    if (!openedMenu || openedMenu === menuName || compatibleMenus.includes(openedMenu)) {
      return;
    }
    onOtherMenuOpen();
  };
  window.addEventListener(OVERLAY_MENU_CHANGE_EVENT, handleOverlayChange);
  return () => {
    window.removeEventListener(OVERLAY_MENU_CHANGE_EVENT, handleOverlayChange);
  };
}
